module.exports = __webpack_public_path__ + "static/fun-time/audio/karta2//8_blue.mp3";